import styled from 'styled-components';
import { Collapse } from 'antd';

const { Panel } = Collapse;

interface StyleProps {
  isMobile: boolean;
}

export const S = {
  Container: styled.section`
    display: flex;
    flex-direction: column;
    position: relative;
    height: 100%;
    padding: 10px;
    padding-left: 15px;
    flex: 1;
    overflow-x: visible;
  `,
  ListContainer: styled.div`
    width: 100%;
    height: 100%; // or a specific height, like 400px
    display: flex;
    flex-direction: column;
  `,
  Header: styled.div`
    padding-left: 5px;
    padding-bottom: 5px;
    display: flex;
    align-items: left;
    justify-content: space-between;
  `,
  SubHeader: styled.div`
    display: flex;
    align-items: center;   /* centers vertically */
    justify-content: align-start;
  `,
  Title: styled.span`
    font-size: 21px;
    font-weight: bold;
  `,
  Buttons: styled.div`
    display: flex;
    gap: 8px; /* spacing between Save and Close */
  `,
  Name: styled.span`
    font-size: 16px;  
    font-weight: bold;
    margin-right: 8px;    
  `,
  Description: styled.span`
    font-size: 16px;  
    font-weight: bold;
    color: #777; // light gray text
    margin-bottom: 5px;      
  `,
  TotalLength: styled.span`
    font-size: 16px;  
    font-weight: bold;
    color: #777; // light gray text    
  `,
  Info: styled.ul`
    margin: 0;
    padding: 0;
  `,
  DetailSection: styled.div`
    padding-left: 5px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid
      ${({ theme }) => theme.pointCard.colors.backgroundContainer};    
  `,
  Li: styled.li`
    display: inline-block;
    position: relative;
    color: #777; // light gray text    

    &:not(:last-child) {
      margin-right: 18px;
    }
  `,
  Collapse: styled(Collapse)<StyleProps>`
    border-radius: ${({ theme }) =>
      theme.guidesOptionsPanel.dimensions.borderRadius}px;
    ${({ isMobile }) =>
      isMobile
        ? `
        max-width: 36px;
        min-width: 36px;
      `
        : `
        max-width: 42px;
        min-width: 42px;
      `}

    &&& .ant-collapse-item {
      border-radius: ${({ theme }) =>
        theme.guidesOptionsPanel.dimensions.collapseItemBorderRadius};
    }

    &&& .ant-collapse-header {
      padding: 12px 16px;
    }

    &&& .ant-collapse-arrow {
      padding: 0;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    &&& .ant-collapse-content-box {
      padding: 5px;
    }

    &&& .ant-collapse-content {
      border-radius: 0 0 12px 12px;
    }
  `,
  Panel: styled(Panel)``,
  IconWrapper: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2px 0;
    cursor: pointer;
  `,
};
